import { createInstance } from "i18next";
import { initReactI18next } from "react-i18next";
import { savedInterfaceLanguage } from "./language";
import { en } from "./locales/en";
import { zhHK } from "./locales/zh-HK";

declare module "i18next" {
  interface CustomTypeOptions {
    defaultNS: "auth";
    resources: typeof zhHK;
    strictKeyChecks: true;
  }
}

export const i18n = createInstance();

// Bundle the source language so the first render and cached offline startup
// never depend on a translation server or language-detection request.
void i18n.use(initReactI18next).init({
  lng: savedInterfaceLanguage(),
  fallbackLng: "zh-HK",
  supportedLngs: ["zh-HK", "en"],
  load: "currentOnly",
  defaultNS: "auth",
  ns: Object.keys(zhHK),
  resources: { "zh-HK": zhHK, en },
  initAsync: false,
  saveMissing: false,
  interpolation: { escapeValue: false },
  react: { useSuspense: false },
});

function updateDocumentLanguage() {
  if (typeof document !== "undefined") document.documentElement.lang = i18n.resolvedLanguage || "zh-HK";
}
i18n.on("languageChanged", updateDocumentLanguage);
updateDocumentLanguage();

export function interfaceLocale() {
  return i18n.resolvedLanguage === "en" ? "en-HK" : "zh-HK";
}

export { Trans, useTranslation } from "react-i18next";
